export const STATUS_ITEMS = ['Ativo', 'Inativo']
export const YES_NO_ITEMS = ['Sim', 'Nāo']